import { HtmlPanel } from '../HtmlPanel/HtmlPanel';
import * as React from 'react';
import { ErrorMessage } from '@gje/forms/lib/error-message';
import classNames from 'classnames';
import {
    isOkq8,
    isVillaagarna
} from '../../../services/partners/partnersService';

export const Checkbox = ({ input, label, meta: { touched, error } }) => {
    return (
        <div
            className={classNames('form-group input-large', {
                'margin-top-45': isOkq8()
            })}>
            <input
                type="checkbox"
                id={input.name}
                className="gj-checkbox"
                onChange={input.onChange}
                value={input.value}
                name={input.name}
            />
            <label
                htmlFor={input.name}
                className={classNames('no-underline', {
                    'margin-top-6 okq8-grey-label-not-bold': isOkq8()
                })}>
                <HtmlPanel>{label}</HtmlPanel>
            </label>
            <ErrorMessage
                className={classNames(
                    {
                        'villaagarna-orange-bg-color': isVillaagarna()
                    },
                    { 'okq8-error': isOkq8() }
                )}
                errorText={error}
                invalid={touched && error}
            />
        </div>
    );
};
